const addDotsToNav = (amount) => {
  let listItems = "";
  for (let i = 0; i < amount; i++) {
    listItems += `<li class="nav-dot ${
      i === 0 ? "active" : ""
    }" id="nav-dot-${i}" data-dot-index=${i} aria-setsize="${amount}" aria-posinset="${
      i + 1
    }" 
    >
    <button ${i === 0 ? 'aria-current="true"' : ""}>
      <span class="sr-only">Go to page ${i + 1} of ${amount}</span>
    </button>
    </li>`;
  }
  return listItems;
};

export const createDots = (products, pageSize) => {
  let pages = Math.ceil(products.length / pageSize);
  if (pages * 2 < products.length && !Number.isInteger(pageSize) ) {
    pages += 1;
  }
  return `<ul class="nav-dots" data-page-size="${pageSize}">${addDotsToNav(
    pages
  )}</ul>`;
};
